import { MeetingService } from "@/services/meeting/meeting.service";
import { DefaultMeetingSession } from "amazon-chime-sdk-js";
import { State } from "@/store/modules/meeting/index";

const _meetingService = new MeetingService();

const setOpenDevicesConfigAction = ({ commit }, payload) => {
  commit("setOpenDevicesConfig", payload);
};

const setOpenBackgroundImagesAction = ({ commit }, payload) => {
  commit("setOpenBackgroundImages", payload);
};

const setSelectedVideoInputAction = ({ commit }, payload) => {
  commit("setSelectedVideoInput", payload);
};

const setSelectedAudioInputAction = ({ commit }, payload) => {
  commit("setSelectedAudioInput", payload);
};
const setSelectedAudioOutputAction = ({ commit }, payload) => {
  commit("setSelectedAudioOutput", payload);
};

const setMeetingDataAction = ({ commit }, payload): void => {
  const { meeting, attendee } = payload;
  commit("setMeeting", meeting);
  commit("setAttendee", attendee);
};

const setMeetingSessionAction = ({ commit }, payload) => {
  commit("setMeetingSession", payload);
};

const setCameraEnabledAction = ({ commit }, payload) => {
  commit("setCameraEnabled", payload);
};

const setMicEnabledAction = ({ commit }, payload) => {
  commit("setMicEnabled", payload);
};

const setColumnDisplayAction = ({ commit }, payload) => {
  commit("setColumnDisplay", payload);
};

const setSharedScreenEnabledAction = ({ commit }, payload) => {
  commit("setSharedScreenEnabled", payload);
};

const setActiveParticipantAction = ({ commit }, payload) => {
  commit("setActiveParticipant", payload);
};

const setVideoUrlAction = ({ commit }, payload) => {
  commit("setVideoUrl", payload);
};

const setMeetingTypeAction = ({ commit }, payload) => {
  commit("setMeetingType", payload);
};

const setOpenWebinarUrlAction = ({ commit }, payload) => {
  commit("setOpenWebinarUrl", payload);
};
const setRoomIdWebinarUpdateAction = ({ commit }, payload) => {
  commit("setRoomIdWebinarUpdate", payload);
};

const setRoomIdAction = ({ commit }, payload) => {
  commit("setRoomId", payload);
};

const setWebinarActiveAction = ({ commit }, payload) => {
  commit("setWebinarActive", payload);
};

const setBackgroundProcessorsAction = ({ commit }, payload) => {
  commit("setBackgroundProcessors", payload);
};

const setBackgroundIsSupportedAction = ({ commit }, payload) => {
  commit("setBackgroundIsSupported", payload);
};

const setBackgroundImageAction = ({ commit }, payload) => {
  commit("setBackgroundImage", payload);
};

const setBackgroundEnabled = ({ commit }, payload) => {
  commit("setBackgroundEnabled", payload);
};

const setBlurEnabled = ({ commit }, payload) => {
  commit("setBlurEnabled", payload);
};

const setBlurAmountAction = ({ commit }, payload) => {
  commit("setBlurAmount", payload);
};

const setBlurProcessorsAction = ({ commit }, payload) => {
  commit("setBlurProcessors", payload);
};

const setTransformDeviceAction = ({ commit }, payload) => {
  commit("setTransformDevice", payload);
};

const setBlurIsSupportedAction = ({ commit }, payload) => {
  commit("setBlurIsSupported", payload);
};

const setVoiceTransformDevice = ({ commit }, payload) => {
  commit("setVoiceTransformDevice", payload);
};

const setVoiceIsEnabledAction = ({ commit }, payload) => {
  commit("setVoiceIsEnabled", payload);
};

const setVoiceIsSupportedAction = ({ commit }, payload) => {
  commit("setVoiceIsSupported", payload);
};

const setPressToTalkEnabledAction = ({ commit }, payload) => {
  commit("setPressToTalkEnabled", payload);
};

const addUsersInCallAction = ({ commit }, payload) => {
  commit("addUsersInCall", payload);
};
const removeUsersInCallAction = ({ commit }, payload) => {
  commit("removeUsersInCall", payload);
};
const setUsersInCallAction = ({ commit }, payload) => {
  commit("setUsersInCall", payload);
};

const setIsFirstConnectionAction = ({ commit }, payload) => {
  commit("setIsFirstConnection", payload);
};

const setCallIsRecordAction = ({ commit }, payload) => {
  commit("setCallIsRecord", payload);
};

const setActiveGameAction = ({ commit }, payload) => {
  commit("setActiveGame", payload);
};

const setOpenMeetingUrlAction = ({ commit }, payload) => {
  commit("setOpenMeetingUrl", payload);
};

const setMeetinAttendeeAction = ({ commit }, payload): void => {
  commit("setAttendee", payload);
};

const setIsVideoUrlLockedByAdminAction = ({ commit }, payload): void => {
  commit("setIsVideoUrlLockedByAdmin", payload);
};

const setLayoutTypeAction = ({ commit }, payload): void => {
  commit("setLayoutType", payload);
};

const setFocusModeAction = ({ commit }, payload): void => {
  commit("setFocusMode", payload);
};
const joinMeetingAction = (
  { commit },
  { roomId, pinToJoin = null, callback, callbackError }
) => {
  _meetingService
    .joinMeeting(roomId, pinToJoin)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const openWebinarAction = ({ commit }, { roomId, callback, callbackError }) => {
  _meetingService
    .openWebinar(roomId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createMeetingOneToOneAction = (
  { commit },
  { userId, callback, callbackError }
) => {
  _meetingService
    .createMeetingOneToOne(userId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const closeWebinarAction = (
  { commit, state, dispatch },
  { roomId, callback, callbackError }
) => {
  _meetingService
    .closeWebinar(roomId)
    .then((response) => {
      dispatch("closeMeetingSession");
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const joinMeetingOneToOneAction = (
  { commit },
  { meetingId, callback, callbackError }
) => {
  _meetingService
    .joinMeetingOneToOne(meetingId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const changeVideoUrlAction = (
  { commit },
  { roomId, data, callback, callbackError }
) => {
  _meetingService
    .changeVideoUrl(roomId, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const closeMeetingOneToOneAction = (
  { commit, state, dispatch },
  { meetingId, attendee, callback, callbackError }
) => {
  dispatch("closeMeetingSession");
  _meetingService
    .closeMeetingOneToOne(meetingId, attendee)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const leaveMeetingAction = (
  { commit, state, dispatch },
  { roomId, callback, callbackError }
) => {
  dispatch("closeMeetingSession");
  _meetingService
    .leaveRoomMeeting(roomId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const closeMeetingSession = async ({ commit, state }): Promise<void> => {
  if (state.meetingSession && state.meetingSession.audioVideo) {
    if (state.shareScreenEnabled)
      state.meetingSession.audioVideo.stopContentShare();
    state.meetingSession.audioVideo.realtimeMuteLocalAudio();
    state.meetingSession.audioVideo.realtimeUnsubscribeToAttendeeIdPresence();
    state.meetingSession.audioVideo.realtimeUnsubscribeFromVolumeIndicator();
    state.meetingSession.audioVideo.unsubscribeFromActiveSpeakerDetector();
    state.meetingSession.audioVideo.stopLocalVideoTile();
    state.meetingSession.audioVideo.unbindAudioElement();
    // state.meetingSession.audioVideo.chooseVideoInputDevice(null);
    // state.meetingSession.audioVideo.chooseAudioInputDevice(null);
    state.meetingSession.audioVideo.stop();
    if (state.transformDevice) {
      await state.transformDevice.stop();
      commit("setBlurProcessors", []);
      commit("setBackgroundProcessors", []);
      commit("setTransformDevice", null);
    }
    if (state.voiceTransformDevice) {
      await state.voiceTransformDevice.stop();
      commit("setVoiceTransformDevice", null);
    }
  }
  commit("setCameraEnabled", true);
  commit("setMicEnabled", true);
  commit("setSharedScreenEnabled", false);
  commit("setColumnDisplay", true);
  commit("setActiveParticipant", null);
  commit("setMeeting", null);
  commit("setAttendee", null);
  commit("setFocusMode", false);
};

const setRoomNameAction = ({ commit }, payload) => {
  commit("setRoomName", payload);
};

const setShowCallModalAction = ({ commit }, payload) => {
  commit("setShowCallModal", payload);
};

const setShowCallFromSpaceUserAction = ({ commit }, payload) => {
  commit("setShowCallFromSpaceUser", payload);
};

const setCountPlayerInCallAction = ({ commit }, payload): void => {
  commit("setCountPlayerInCall", payload);
};

const startAutoVideoAction = ({ commit }, { roomId, callback, callbackError }
) => {
  _meetingService
    .startAutoVideo(roomId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const stopAutoVideoAction = ({ commit }, { autoVideoId, callback, callbackError }
) => {
  _meetingService
    .stoptAutoVideo(autoVideoId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const validateAutoVideoAction = ({ commit }, { autoVideoId, data, callback, callbackError }
) => {
  _meetingService
    .validateAutoVideo(autoVideoId, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const setRoomAutoVideoIdAction = ({ commit }, payload: any) => {
  commit("setRoomAutoVideoId", payload);
};

export default {
  setOpenDevicesConfigAction,
  setOpenBackgroundImagesAction,
  setSelectedVideoInputAction,
  setSelectedAudioInputAction,
  setSelectedAudioOutputAction,
  joinMeetingAction,
  setMeetingDataAction,
  setMeetingSessionAction,
  setCameraEnabledAction,
  setMicEnabledAction,
  setColumnDisplayAction,
  setSharedScreenEnabledAction,
  setActiveParticipantAction,
  setVideoUrlAction,
  setMeetingTypeAction,
  openWebinarAction,
  closeWebinarAction,
  changeVideoUrlAction,
  createMeetingOneToOneAction,
  joinMeetingOneToOneAction,
  closeMeetingOneToOneAction,
  setOpenWebinarUrlAction,
  setRoomIdWebinarUpdateAction,
  leaveMeetingAction,
  closeMeetingSession,
  setRoomIdAction,
  setWebinarActiveAction,
  setBackgroundProcessorsAction,
  setBackgroundIsSupportedAction,
  setBackgroundImageAction,
  setBackgroundEnabled,
  setBlurEnabled,
  setBlurAmountAction,
  setBlurProcessorsAction,
  setTransformDeviceAction,
  setBlurIsSupportedAction,
  setVoiceTransformDevice,
  setVoiceIsEnabledAction,
  setVoiceIsSupportedAction,
  setPressToTalkEnabledAction,
  addUsersInCallAction,
  removeUsersInCallAction,
  setUsersInCallAction,
  setIsFirstConnectionAction,
  setCallIsRecordAction,
  setActiveGameAction,
  setRoomNameAction,
  setOpenMeetingUrlAction,
  setMeetinAttendeeAction,
  setIsVideoUrlLockedByAdminAction,
  setLayoutTypeAction,
  setShowCallModalAction,
  setShowCallFromSpaceUserAction,
  setFocusModeAction,
  setCountPlayerInCallAction,
  startAutoVideoAction,
  stopAutoVideoAction,
  validateAutoVideoAction,
  setRoomAutoVideoIdAction,
};
